module.exports = __webpack_public_path__ + "static/media/MAC.a81b37b6.png";